<script setup>
import { useI18n } from "vue-i18n";

const config = useRuntimeConfig()
const router = useRouter()
const i18n = useI18n()
const route = useRoute()

// Basis-Daten
const articleSlug = route.params.id
const lang = i18n.locale.value

//https://api.storyblok.com/v2/cdn/stories/posts/beeinflusst-die-dauer-des-rauchens-den-entzug?version=draft&resolve_relations=category%2Cauthor%2Creviewer&language=default&token=ZKVz5vYrHivRPiqP6HcOdwtt&cv=1710835609&resolve_level=2

console.log('Loading article:', articleSlug)

// ✅ Direkter useAsyncStoryblok-Call
const storyData = await useAsyncStoryblok(`posts/${articleSlug}`, {
  version: (config.public.blog?.mode || 'published'),
  resolve_relations: 'category,author,reviewer',
  language: lang === 'en' ? 'default' : lang
})

console.log('Storyblok data:', storyData.value)

// ✅ Statische Datenverarbeitung - nur auf Server
const story = storyData.value
const rels = story?.rels || []

// Author und Reviewer direkt finden
const author = rels.find((x) => x.uuid === story?.content.author)
const reviewer = rels.find((x) => x.uuid === story?.content.reviewer)

// Categories filtern
const categories = story?.content.category 
  ? story.content.category
      .filter((id) => id !== config.public.blog?.categoryUUID)
      .map((id) => rels.find((x) => x.uuid === id))
      .filter(Boolean)
  : []

// Paths für Navigation
const deSlug = story?.translated_slugs?.find((x) => x.lang === 'de')?.path.split('/').pop() || ''
const paths = {
  enPath: `/posts/${story?.slug || ''}`,
  dePath: `/de/posts/${deSlug}`
}

// Route definition
if (story && paths.enPath) {
  defineI18nRoute({
    paths: {
      en: paths.enPath,
      de: paths.dePath,
    },
  })
}

// SEO Meta-Daten
if (story) {
  const title = story.content.metatags?.title || story.content.title
  const description = story.content.metatags?.description || extractPlainText(story.content.copy)
  const image = story.content.image?.filename ? story.content.image.filename + '/m/' : ''
  const imageAlt = story.content.image?.alt || story.content.title || ''
  
  const baseUrl = config.public.hostname || 'http://localhost:3000'
  const currentUrl = baseUrl + router.currentRoute.value.fullPath
  
  useServerSeoMeta({
    title: title,
    description: description,
    keywords: story.content.keywords || '',
    author: author?.name || 'Smoxy',
    ogTitle: title,
    ogDescription: description,
    ogImage: image,
    ogImageAlt: imageAlt,
    ogType: 'article',
    ogUrl: currentUrl,
    twitterCard: 'summary_large_image',
    twitterTitle: title,
    twitterDescription: description,
    twitterImage: image,
    robots: 'index,follow',
  })
  
  console.log('Story loaded:', story.name)
  console.log('Author:', author?.name)
  console.log('Categories:', categories.length)
}
</script>

<template>
  <div class="overflow-x-hidden bg-newdark-800">
    <Header theme="dark" />
    
    <!-- Content -->
    <StoryblokComponent 
      v-if="story" 
      :blok="story.content" 
      :story="story" 
      :author="author" 
      :reviewer="reviewer" 
      :categories="categories"   
    />
    
    <!-- Footer -->
    <Footer 
      v-if="story" 
      theme="dark" 
      :en-slug="paths.enPath" 
      :de-slug="paths.dePath" 
    />
  </div>
</template>